import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { get, inRange, parseInt } from 'lodash';

import { formatLabel } from '../../../../Utils/Post/budget';
import LinearProgress from '../../../DesignSystem/LinearProgress';

function UserVotesInfo({ post, parent, space }: any) {
  const postOrParent = (attributePath: any) => get(parent || post, attributePath);
  const votingOptions = postOrParent('voting_options');
  const budget = postOrParent('budget');
  const totalVotes = postOrParent('meta.user_votes_info.total_votes');
  const votesLeft = Math.max(0, (votingOptions?.max_votes || 0) - totalVotes);
  const budgetSpent = postOrParent('meta.user_votes_info.budget_spent');
  const budgetLeft = postOrParent('meta.user_votes_info.budget_left') || budget;
  const intl = useIntl();

  const percentRemaining = Math.min((parseInt(budgetSpent, 10) * 100) / parseInt(budget, 10), 100);

  let voteInfo;
  let budgetInfo;

  if (votingOptions.min_votes) {
    if (totalVotes < votingOptions.min_votes) {
      voteInfo = (
        <Box sx={{ mb: 2 }}>
          <span role="img" aria-label="Warning">
            ⚠️{' '}
          </span>{' '}
          <FormattedMessage
            id="USER_VOTES_INFO.MIN_VOTES_WARNING"
            values={{
              count: votingOptions.min_votes - totalVotes,
              strong: (chunk: any) => <strong>{chunk}</strong>,
            }}
          />
        </Box>
      );
    }

    if (
      inRange(
        totalVotes,
        votingOptions.min_votes,
        votingOptions?.max_votes ? votingOptions.max_votes + 1 : Infinity,
      )
    ) {
      voteInfo = (
        <Box sx={{ mb: 2 }}>
          <span role="img" aria-label="Tada">
            🎉
          </span>{' '}
          <FormattedMessage id="USER_VOTES_INFO.VALID_PARTICIPATION" />
          {!!votesLeft && (
            <>
              {' '}
              <FormattedMessage
                id="USER_VOTES_INFO.MAX_VOTES_WARNING"
                values={{ count: votesLeft, strong: (chunk: any) => <strong>{chunk}</strong> }}
              />
            </>
          )}
        </Box>
      );
    }
  }

  if (votingOptions.budget_rule) {
    budgetInfo = (
      <Box>
        <Box sx={{ mb: 1 }}>
          <Typography>
            <FormattedMessage
              id="POSTS.BUDGET.REMAINING_BUDGET"
              values={{
                remaining: formatLabel(intl, budgetLeft, space.currency.key),
                strong: (chunk: any) => <strong>{chunk}</strong>,
              }}
            />
          </Typography>
        </Box>
        <LinearProgress
          value={percentRemaining}
          title={formatLabel(intl, budgetLeft, space.currency.key)}
        />
      </Box>
    );
  }

  return (
    <>
      {voteInfo}
      {budgetInfo}
    </>
  );
}

export default UserVotesInfo;
